exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// Module
exports.push([module.id, ".muidocs-icon-custom-github:before {\n\tcontent: '\\e625';\n}\n", ""]);

